
const Calculators = {
  IRA_RETIRE: 'ira_retire',
  RMD_SINGLE: 'rmd_single',
  RMD_YOUNGER: 'rmd_younger',
  POTENTIAL: "potential",
};

export { Calculators };
